var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking"},[_c('page-header',{attrs:{"title":"Trackings","breadcrumb":"Dashboard  > Bookings & Shipments  > Trackings"}}),_c('tracking-data-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }